import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
const METRIC = 'cm';
const IMPERIAL = 'inches';
const BodyMeasurements = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = useTranslation();
    const { sizeChart } = props;
    const [currentMetrics, setCurrentMetrics] = useState(window.country == 'US' ? IMPERIAL : METRIC);
    const [selectedCountry, setSelectedCountry] = useState((_b = (_a = sizeChart.sizechartdata) === null || _a === void 0 ? void 0 : _a.countries.find((el) => el.id == window.country)) !== null && _b !== void 0 ? _b : (_c = sizeChart.sizechartdata) === null || _c === void 0 ? void 0 : _c.countries.filter((c) => c.id != 'MONCLER')[0]);
    const [table, setTable] = useState({});
    const sizeChartRef = useRef();
    useEffect(() => {
        if (sizeChartRef.current) {
            const maxColumnHeight = Array.from(sizeChartRef.current.querySelectorAll('.column .column-head')).reduce((previous, current) => {
                return current.clientHeight > previous ? current.clientHeight : previous;
            }, 0);
            sizeChartRef.current.style.setProperty('--sizechart-height', maxColumnHeight + 'px');
        }
    }, [props.isSelected]);
    useEffect(() => {
        var _a, _b;
        if (sizeChart && sizeChart.content) {
            const localtable = {};
            sizeChart.content.forEach((chart, i) => {
                let chartTitle = chart.title ? chart.title : 'cm';
                const decodedMap = decodeURI(sizeChart.content[i].content);
                localtable[chartTitle] = decodedMap.split('\n').map((el) => el.split('\t'));
            });
            setTable(localtable);
        }
        if (sizeChart && (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.id) !== window.country && ((_a = sizeChart.sizechartdata) === null || _a === void 0 ? void 0 : _a.defaultSizeConversion)) {
            let checkDefaultSizeConversion = (_b = sizeChart.sizechartdata) === null || _b === void 0 ? void 0 : _b.defaultSizeConversion.find((s) => s.id == window.country);
            if (checkDefaultSizeConversion) {
                let defaultSizeConversion = sizeChart.sizechartdata.countries.find((c) => c.id == checkDefaultSizeConversion.defaultSizeConversion);
                setSelectedCountry(defaultSizeConversion);
            }
        }
    }, [sizeChart]);
    const regionNames = useMemo(() => new Intl.DisplayNames([window.language], { type: 'region', fallback: 'code' }), []);
    const metricLabel = useMemo(() => {
        if (!sizeChart) {
            return '';
        }
        return sizeChart.mannequinGender != 'dog' ? 'sizeguide.uom.kgcm' : 'sizeguide.uom.cm';
    }, [sizeChart]);
    const imperialLabel = useMemo(() => {
        if (!sizeChart) {
            return '';
        }
        return sizeChart.mannequinGender != 'dog' ? 'sizeguide.uom.inchespounds' : 'sizeguide.uom.inches';
    }, [sizeChart]);
    const metricSelector = () => (React.createElement("fieldset", { className: "switch fieldset--plain" },
        React.createElement("label", { className: "radio" },
            React.createElement("input", { type: "radio", name: "metrics", onChange: () => {
                    setCurrentMetrics(METRIC);
                }, defaultChecked: currentMetrics === METRIC, "data-unit-value": "1", className: currentMetrics === METRIC ? 'switch__item selected' : 'switch__item' }),
            t(metricLabel)),
        React.createElement("label", { className: "radio" },
            React.createElement("input", { type: "radio", name: "metrics", onChange: () => {
                    setCurrentMetrics(IMPERIAL);
                }, defaultChecked: currentMetrics === IMPERIAL, "data-unit-value": "0", className: currentMetrics === IMPERIAL ? 'switch__item selected' : 'switch__item' }),
            t(imperialLabel))));
    return (React.createElement("div", { className: "sizechart", ref: sizeChartRef },
        (!!sizeChart.content || (!!sizeChart.sizechartdata && !!sizeChart.sizechartdata.sizes && typeof Object.values(sizeChart.sizechartdata.sizes)[0] !== 'string')) && (React.createElement("div", { className: "sizechart__filters form-group" }, metricSelector())),
        ((_d = sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.sizechartdata) === null || _d === void 0 ? void 0 : _d.description) && (React.createElement("p", { className: "sizechart__description font__title" }, t('sizechart.description.' + sizeChart.sizechartdata.description.toLowerCase()))),
        !!sizeChart.sizechartdata ? (React.createElement(React.Fragment, null,
            !sizeChart.sizechartdata.hideCountrySelector && (React.createElement("div", { className: "form-group country-select" },
                React.createElement("label", { className: "form-group__label", htmlFor: "country" }, t('label.country')),
                React.createElement("div", { className: "form-select mb-12" },
                    React.createElement("select", { name: "country", value: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.id, onChange: (e) => {
                            setSelectedCountry(sizeChart.sizechartdata.countries.find((c) => c.id == e.target.value));
                        } }, sizeChart.sizechartdata.countries
                        .filter((c) => c.id != 'MONCLER')
                        .map((c, i) => (React.createElement("option", { key: i, value: c.id }, c.id.length == 2 ? regionNames.of(c.id) : c.id))))))),
            React.createElement("div", { className: "custom-table" },
                React.createElement("div", { className: "column fixed-col" },
                    React.createElement("span", { className: "column-head font__title" }, t('sizechart.labelsize.default')),
                    sizeChart.sizechartdata.countries
                        .find((c) => c.id == 'MONCLER')
                        .values.map((s, i) => (React.createElement("span", { className: "primary-xs", key: i }, s)))),
                React.createElement("div", { className: "scrollable-area" },
                    selectedCountry && (React.createElement("div", { className: "column" },
                        React.createElement("span", { className: "column-head font__title" }, t(`sizechart.labelsize.${(_e = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.id) === null || _e === void 0 ? void 0 : _e.toLowerCase()}`)), selectedCountry === null || selectedCountry === void 0 ? void 0 :
                        selectedCountry.values.map((s, i) => (React.createElement("span", { className: "primary-xs", key: i }, s))))),
                    Object.keys(sizeChart.sizechartdata.labelsOnImage).map((c, i) => {
                        return (React.createElement("div", { key: i, className: "column" },
                            React.createElement("span", { className: "column-head font__title" }, t(sizeChart.sizechartdata.labelsOnImage[c])),
                            sizeChart.sizechartdata.countries
                                .find((c) => c.id == 'MONCLER')
                                .values.map((s, i) => {
                                if (sizeChart.sizechartdata.sizes[s]) {
                                    return (React.createElement("span", { className: "primary-xs", key: i },
                                        sizeChart.sizechartdata.sizes[s][c][currentMetrics],
                                        ' '));
                                }
                            })));
                    }))),
            React.createElement("p", { className: "primary-xs" }, t('sizechart.bodymeasurements')))) : (React.createElement("table", { className: "table" },
            React.createElement("thead", null,
                React.createElement("tr", null, (_f = table[currentMetrics]) === null || _f === void 0 ? void 0 : _f[0].map((h, i) => (React.createElement("th", { key: i }, h))))),
            React.createElement("tbody", null, (_g = table[currentMetrics]) === null || _g === void 0 ? void 0 : _g.map((row, rowI) => {
                if (rowI === 0) {
                    return;
                }
                return (React.createElement("tr", { key: rowI }, row.map((item, itemI) => (React.createElement("td", { key: itemI }, item)))));
            }))))));
};
export default BodyMeasurements;
